var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-submit row" }, [
    _c(
      "div",
      { staticClass: "col-xs-12 col-md-6" },
      [
        _vm.showCancel
          ? _c(
              "x-button",
              {
                staticClass: "cancel-btn md-raised light",
                attrs: { disabled: _vm.submitting },
                on: { click: _vm.onCancel }
              },
              [
                _c("icn-close", { attrs: { color: "white" } }),
                _vm._v("\n      " + _vm._s(_vm.$t("buttons.cancel")) + "\n    ")
              ],
              1
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-xs-12 col-md-6" },
      [
        _c(
          "x-button",
          {
            staticClass: "md-raised md-primary submit-btn",
            class: _vm.submitting && "submitting",
            attrs: { disabled: _vm.submitting || _vm.disabled, type: "submit" },
            on: { click: _vm.onSubmit }
          },
          [
            _c("update-profile-icon", {
              staticClass: "update-icon",
              attrs: { loading: _vm.submitting }
            }),
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.submitText || _vm.$t("buttons.update-informations")
                ) +
                "\n    "
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }